import React, { useEffect, useState } from 'react';
import Resizer from "react-image-file-resizer";
import {Close} from "../../icons/icons";

const MultiUploader = ({ title, name, en, onChange, defaultValue, id = 1, onClear }) => {
  const [currentImages, setCurrentImages] = useState([]);
  const [error, setError] = useState(false);
  const [src, setSrc] = useState([]);

  useEffect(() => {
    if (defaultValue) {
      const newSrc = Array.isArray(defaultValue) ? defaultValue : [defaultValue];
      setSrc(newSrc.map(url => "https://api.flysepehr.com/storage" + url));
    }
  }, [defaultValue]);

  useEffect(() => {
    setCurrentImages([]);
  }, [onClear]);

  const resizeFile = (file) => {
    return new Promise((resolve) => {
      Resizer.imageFileResizer(
        file,
        1000,
        1000,
        "JPEG",
        50,
        0,
        (uri) => {
          resolve(uri);
        },
        "base64"
      );
    });
  };

  const upload = async (e) => {
    const files = e.target.files;
    const newImages = [];

    for (let i = 0; i < files.length; i++) {
      const file = files[i];

      if (file?.type?.includes("image")) {
        const resizedImage = await resizeFile(file);
        newImages.push(resizedImage);
      } else {
        setError(true);
        setTimeout(() => setError(false), 3000);
        return;
      }
    }

    setCurrentImages([...currentImages, ...newImages]);
    onChange({ name: name, value: [...currentImages, ...Array.from(files)] });
  };

  const handleImageDelete = (index) => {
    const updatedImages = currentImages.filter((_, i) => i !== index);
    onChange({ name: name, value: [...updatedImages] });
    setCurrentImages(updatedImages);
  };

  return (
    <div className="w-full flex flex-col items-center ">
      <label htmlFor={name + id} className="flex text-gray-700 font-bold justify-center items-center cursor-pointer w-full h-full">
        <div className={`border-dashed border-2 w-full h-full flex justify-center items-center rounded-lg ${error ? "border-orange-500" : "border-gray-300"} min-h-[200px]`}>
          {currentImages.length > 0 || src.length > 0 ? (
            <div className="flex flex-wrap justify-center">
              {currentImages.map((image, index) => (
                <div key={index} className="relative m-2">
                  <img src={image} alt={`Uploaded ${index}`} className="w-32 h-32 object-cover rounded-lg" />
                  <button onClick={() => handleImageDelete(index)} className="absolute top-0 right-0 bg-red-500 text-white rounded-full p-1 bg-gray-300 z-10">
                    <Close/>
                  </button>
                </div>
              ))}
            </div>
          ) : (
            <span className="text-gray-500"> {en ? "Choose Files" : "فایل را انتخاب کنید"}</span>
          )}
        </div>
      </label>
      <input
        id={name + id}
        type="file"
        onChange={upload}
        accept=".pdf,.jpg,.jpeg,.png"
        multiple
        className="absolute opacity-0 -z-10"
      />
    </div>
  );
};

export default MultiUploader;
